import {Box, Grid, Text} from '@primer/react-brand'

import type {GenericContent, GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

import IdeList from '../_components/IdeList'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function IdeSection(props: Props) {
  const {contentfulContent} = props

  const {content} = contentfulContent.fields
  const heading = (content?.[0] as GenericContent | undefined)?.fields.heading

  return (
    <Grid as="section">
      <Grid.Column span={12}>
        {heading ? (
          <div className="d-flex flex-justify-center pr-pt-6 pb-2">
            <Text as="p" size="200" variant="muted" weight="normal" align="center" className="pr-mb-5">
              {heading}
            </Text>
          </div>
        ) : null}

        <IdeList type="small" location="pricing-section" />
      </Grid.Column>
      <Grid.Column span={12}>
        <Box
          marginBlockEnd={{narrow: 48}}
          paddingBlockEnd={{narrow: 48}}
          borderBlockEndWidth="thin"
          borderColor="default"
          borderStyle="solid"
        />
      </Grid.Column>
    </Grid>
  )
}
